import { CardMedia } from '@mui/material';

const LogoName = 'SOIC-Global-Logo.svg';

const logoWidth = '180px';

export const Logo1 = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Logo"
      sx={{ width: logoWidth, m: 3 }}
    />
  );
};

export const LogoEditApplication = (): JSX.Element => {
  return (
    <CardMedia
      component="img"
      src={`/images/${LogoName}`}
      alt="Logo"
      sx={{ width: '200px', m: 3, my: 2 }}
    />
  );
};

export const LogoSideBar = (): JSX.Element => {
  return (
    <CardMedia component="img" src={`/images/${LogoName}`} alt="Logo" sx={{ width: logoWidth }} />
  );
};
